import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StaticPreIdvPageComponent } from './static-pre-idv-page/static-pre-idv-page.component';
import { EmbeddedIdvWithOnfidoComponent } from './embedded-idv-with-onfido/embedded-idv-with-onfido.component';
import { IdentityVerifiedComponent } from './identity-verified/identity-verified.component';
import { DirectSalesThankYouPageComponent } from './direct-sales-thank-you-page/direct-sales-thank-you-page.component';
import { InternalUserIdvComponent } from './internal-user-idv/internal-user-idv.component';
import { InternalUserIdentityVerifiedComponent } from './internal-user-identity-verified/internal-user-identity-verified.component';

const routes: Routes = [
    {
        path: "static/verify-your-identity",
        data: {
            pageName: "Identity Verification"
        },
        component: StaticPreIdvPageComponent
    },
    {
        path: "static/verify-with-onfido",
        data: {
            pageName: "Onfido Identity Verification"
        },
        component: EmbeddedIdvWithOnfidoComponent
    },
    {
        path: "static/identity-verified",
        data: {
            pageName: "Identity Verified"
        },
        component: IdentityVerifiedComponent
    },
    {
        path: "static/thank-you",
        data: {
            pageName: "Thank You"
        },
        component: DirectSalesThankYouPageComponent
    },
    {
        path: "static/internal-user-idv",
        data: {
            pageName: "Internal User Identity Verification"
        },
        component: InternalUserIdvComponent
    },
    {
        path: "static/internal-user-identity-verified",
        data: {
            pageName: "Identity Verified"
        },
        component: InternalUserIdentityVerifiedComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class StaticPagesRoutingModule { }
